import { HeaderDetailsStyle } from './styles'
import { Link, useLocation, useHistory } from 'react-router-dom'
import { Breadcrumbs, Typography } from '@mui/material'
import ActionReturn from './action-return'
import HelpPageCurrent from './help-page-current'
import { findCategory } from 'presentation/utils/helpers/helpers'

const HeaderDetails = () => {
  const location = useLocation()
  const history = useHistory()
  const farmName = window.localStorage.getItem('farm-name') ? atob(window.localStorage.getItem('farm-name')) : ''
  const farmKey = window.localStorage.getItem('farm-api-key') ? atob(window.localStorage.getItem('farm-api-key')) : ''

  const items = findCategory(location.pathname)

  return (
    <HeaderDetailsStyle>
      <ActionReturn />
      <div className='headerDetailsUrl'>
        <span>#{farmKey} - {farmName} | </span>
        <Breadcrumbs aria-label="breadcrumb" style={{ color: '#343A40' }}>
          <Link to={{ pathname: '/', state: history.location.pathname }} style={{ color: '#343A40' }} >
            <span className='linkHome'>Home</span>
          </Link>
          {items.map((category) => (
            <Typography key={category.slug} className='divTypography'>{category.title.toUpperCase()}</Typography>
          ))}
        </Breadcrumbs>
      </div>
      <HelpPageCurrent style={{ width: '150px', justifyContent: 'flex-end' }} />
    </HeaderDetailsStyle>
  )
}

export default HeaderDetails
